module.exports = __webpack_public_path__ + "static/media/approved-grey.341b8de9.svg";